import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import MultiRangeSlider from '../../components/multiRangeSlider';

const SearchFormFiltersPrice = ({ for_sales, filters, submitRef }) => {
    const {
        daily_rent_gteq,
        daily_rent_lteq,
        sale_price_gteq,
        sale_price_lteq,
    } = filters;

    const [minVal, setMinVal] = useState(for_sales ? parseInt(sale_price_gteq || 0) : parseInt(daily_rent_gteq || 0));
    const [maxVal, setMaxVal] = useState(for_sales ? parseInt(sale_price_lteq || 1500000) : parseInt(daily_rent_lteq || 1000));

    return (
        <div className="dropdown filtering-btn">
            <button className="btn btn-mod btn-border btn-circle dropdown-toggle price btn-custom-mod" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                Price
                <span className="caret"></span>
            </button>
            <ul className="filter-dropdown-menu dropdown-menu" aria-labelledby="dropdownMenu1">
                <div className="price-container" style={{ padding: "15px" }}>
                    {for_sales ?
                        <>
                            <Form.Control name="q[sale_price_gteq]" value={minVal} onChange={(e) => { }} style={{ display: 'none' }} />
                            <Form.Control name="q[sale_price_lteq]" value={maxVal} onChange={(e) => { }} style={{ display: 'none' }} />
                        </> : <>
                            <Form.Control name="q[daily_rent_gteq]" value={minVal} onChange={(e) => { }} style={{ display: 'none' }} />
                            <Form.Control name="q[daily_rent_lteq]" value={maxVal} onChange={(e) => { }} style={{ display: 'none' }} />
                        </>}
                    <span className="price_show">${minVal} - ${maxVal}</span>
                    {/* <div id="slider-range" className="space"></div> */}
                    <MultiRangeSlider
                        MIN={0}
                        MAX={for_sales ? 1500000 : 1000}
                        STEP={1}
                        values={[minVal, maxVal]}
                        setMaxVal={setMaxVal}
                        setMinVal={setMinVal}
                    />
                    <div className="filter-price">
                        <a href="#" onClick={e => submitRef.current.click()} style={{ color: "#1594b4", backgroundColor: "#fff" }}>Apply Filter</a>
                    </div>
                </div>
            </ul>
        </div>
    );
}

export default SearchFormFiltersPrice;